export default __webpack_public_path__ + "06b942b2f4ed4531ca683855c01f5857.webp";